import React, { forwardRef } from 'react';
import cn from 'classnames';
import {
  Mark,
  MarkContainer,
  RadioContainer,
  RadioInput,
  RadioLabel,
  RadioLabelText,
  RadioText
} from './styled';
import { NewRadioButtonProps } from './types';

export const NewRadioButton = forwardRef<HTMLDivElement, NewRadioButtonProps>(
  (
    {
      data,
      name,
      color,
      stat,
      cypress,
      currentValue,
      onChangeHandler,
      containerClassNames,
      additionalClasses,
      markerPosition = 'right',
      isSelected,
      label,
      additionalControlElement,
      icon
    },
    ref
  ) => {
    const classes = cn(containerClassNames, additionalClasses);
    const isChecked = isSelected || currentValue === data.id;

    return (
      <RadioContainer
        ref={ref}
        className={classes}
        data-cy="radio-container"
        data-stat={stat}
        markerPosition={markerPosition}
      >
        <RadioInput
          type="radio"
          name={name}
          value={data.id}
          onChange={onChangeHandler}
          data-cy={`${cypress}-${data.id}`}
          checked={isChecked}
        />
        {additionalControlElement}
        {label && (
          <RadioLabel data-cy="search-radio__label">
            <RadioLabelText tag="caption_2">{label}</RadioLabelText>
          </RadioLabel>
        )}
        {icon}
        <RadioText
          tag="body_2"
          color={color}
          $isChecked={isChecked}
          data-cy={cypress}
        >
          {data.name}
        </RadioText>

        <MarkContainer $isChecked={isChecked}>
          <Mark />
        </MarkContainer>
      </RadioContainer>
    );
  }
);

NewRadioButton.displayName = 'NewRadioButton';
